import React, { useEffect, useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const ViaticosCheck = ({ id_viaticos_doc, onSubmit, loadSubmit, total }) => {
    const [row, setRow] = useState({
        total_comprobado: '',
        files: []
    });

    useEffect(() => {

    }, [])

    return <FormCustom onSubmit={_ => {
        if (parseFloat(row.total_comprobado) > parseFloat(total)) {
            Helpers.toast.construct({
                response: 'warning',
                message: 'El total comprobado no puede ser mayor al total solicitado',
                toast
            })
            return false;
        }

        let fd = new FormData();
        fd.append('p_id_viaticos_doc', id_viaticos_doc);
        fd.append('p_total_comprobado', row.total_comprobado);
        fd.append('p_file', row.files[0]);
        fd.append('p_total_comprobado', parseFloat(row.total_comprobado))
        fd.append('p_resto_comprobado', (parseFloat(total) - parseFloat(row.total_comprobado).toFixed(2)))

        onSubmit({
            data: fd
        });
    }} loadSubmit={loadSubmit}>
        <Input classNameParent="col-12 mb-3"
            text="Adjuntar Archivos"
            type="file"
            required
            onChange={e => setRow({
                ...row,
                files: e.currentTarget.files
            })}
            accept=".zip"
            invalid="Debe adjuntar al menos un archivo"
        />

        <Input classNameParent="col-12 mb-3"
            text="Total Solicitado"
            value={total}
            className="text-center"
            disabled
            required
        />

        <Input classNameParent="col-12 mb-3"
            text="Total Comprobado"
            className="text-center"
            required
            onChange={e => {
                setRow({
                    ...row,
                    total_comprobado: e.currentTarget.value
                })
            }}
        />

        <div className="col-12 mb-2">
            Total Resto: <strong>{
            !isNaN(parseFloat(total)) && !isNaN(parseFloat(row.total_comprobado)) ?
            (parseFloat(total) - parseFloat(row.total_comprobado)).toFixed(2) : '0.00'}</strong>
        </div>
    </FormCustom>
}

ViaticosCheck.defaultProps = {
    id_viaticos_doc: '',
    onSubmit: () => { },
    loadSubmit: false
}

export default ViaticosCheck;